<div class="catalog">
  @if (catalogError) {
    <div class="catalog-error">
      <div>{{ 'PROCESSINGS.CATALOG.UNREACHABLE' | translate }}</div>
      <code>{{ catalogError }}</code>
      <button type="button" class="catalog-retry" (click)="retry.emit()">
        {{ 'PROCESSINGS.CATALOG.RETRY' | translate }}
      </button>
    </div>
  } @else if (!operations.length) {
    <div class="catalog-note">{{ 'PROCESSINGS.CATALOG.LOADING_OPERATIONS' | translate }}</div>
  } @else {
    <section class="catalog-block">
      <h3 class="catalog-block-title">{{ 'PROCESSINGS.CATALOG.OPERATIONS_TITLE' | translate }}</h3>
      <p class="catalog-note">{{ 'PROCESSINGS.CATALOG.OPERATIONS_HINT' | translate }}</p>

      <div class="catalog-search">
        <fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon>
        <input type="text" [(ngModel)]="search" spellcheck="false"
          [placeholder]="'PROCESSINGS.CATALOG.SEARCH_PLACEHOLDER' | translate" />
        @if (search) {
          <button type="button" class="catalog-search-clear" (click)="clearSearch()"
            [title]="'PROCESSINGS.CATALOG.SEARCH_CLEAR' | translate">
            <fa-icon [icon]="icons.faXmark"></fa-icon>
          </button>
        }
      </div>

      @if (!filtered.length) {
        <div class="catalog-note">{{ 'PROCESSINGS.CATALOG.SEARCH_EMPTY' | translate:{ term: search } }}</div>
      } @else {
        <ul class="operation-list">
          @for (operation of filtered; track operation.id) {
            <li>
              <div class="operation-title">{{ operation.title }}</div>
              <div class="operation-summary">{{ operation.summary }}</div>
            </li>
          }
        </ul>
      }
    </section>

    @if (scopes.length) {
      <section class="catalog-block">
        <h3 class="catalog-block-title">{{ 'PROCESSINGS.CATALOG.SCOPE_TITLE' | translate }}</h3>
        @for (scope of scopes; track scope.id) {
          <div class="scope-item">
            <div class="scope-name">{{ scope.title }}</div>
            <p class="scope-text">{{ scope.explanation }}</p>
          </div>
        }
      </section>
    }
  }
</div>
